// TODO enable eslint
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { compose } from "redux"
import warning from "warning"
import identity from "lodash/identity"
import isPlainObject from "lodash/isPlainObject"
import isNil from "lodash/isNil"
import isFunction from "lodash/isFunction"
import isArray from "lodash/isArray"
import propsflow from "propsflow"

function pureEnhancer(next) {
  return next
}

/* Plugin */

export default (reducers, middlewares, enhancers, enhanceStore = identity) => {
  warning(
    !reducers || isPlainObject(reducers) || isNil(reducers),
    `EnhanceRedux expect reducers to be an plain object, ${typeof reducers} given.`,
  )

  enhancers = compose(
    isArray(enhancers) ? enhancers : isFunction(enhancers) ? [enhancers] : [],
  )

  const extendReducers = ({ reducers: prevReducers = {} }) => ({
    reducers: Object.assign(prevReducers, reducers),
  })

  const enhanceCreateStore = ({ createStore, reducers }) => ({
    createStore: function nextCreateStore(
      rootReducer,
      preloadedState,
      enhancer,
    ) {
      middlewares = isArray(middlewares)
        ? middlewares
        : middlewares
        ? [middlewares]
        : []
      if (
        typeof preloadedState === `function` &&
        typeof enhancer === `undefined`
      ) {
        enhancer = preloadedState
        preloadedState = undefined
      }

      const richEnhancer = compose(
        ...enhancers.concat([enhancer || pureEnhancer]),
      )

      const nextEnhancers = cs => (...args) => {
        const nextCreateStore = richEnhancer(cs)
        const store = nextCreateStore(...args)

        let dispatch = () => {
          throw new Error(
            `Dispatching while constructing your middleware is not allowed. ` +
              `Other middleware would not be applied to this dispatch.`,
          )
        }

        const middlewareAPI = {
          getState: store.getState,
          dispatch: (...args) => dispatch(...args),
        }

        const chain = middlewares.map(mw => mw(middlewareAPI))

        dispatch = compose(...chain)(store.dispatch)

        return {
          ...store,
          dispatch,
        }
      }

      return preloadedState
        ? enhanceStore(createStore(reducers, preloadedState, nextEnhancers))
        : enhanceStore(createStore(reducers, nextEnhancers))
    },
  })

  return propsflow(extendReducers, enhanceCreateStore)
}
